import { MoreVerticalOutlineIcon, ToolsIcon } from '@carboncopyco/icons';
import type { IGlobalTab } from '@carboncopyco/types/desktop';
import { Dropdown, DropdownItem, Navbar, TextBase } from '@carboncopyco/ui';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useEffect, useState } from 'react';
import { useFocusAppService } from '../../hooks/useFocusAppService';
import { TextExtractionExport } from '../TextExtraction';
import { useDownloadExtractedText } from '../TextExtraction/useDownloadExtractedText';
import { RecordingTypes, type IDemo } from '@carboncopyco/types';

export interface NavbarOptionsButtonProps {
  tab: IGlobalTab;
}

export const NavbarOptionsButton = ({ tab }: NavbarOptionsButtonProps) => {
  const flags = useFlags();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { triggerFocus, isAppViewFocus } = useFocusAppService();

  const demo = tab.payload?.demo as IDemo;
  const { downloadExtractedText, isCSVEmpty } = useDownloadExtractedText({
    cloneId: demo?.recordId,
    cloneRevisionId: demo?.recordRevisionId,
    organizationId: demo?.organizationId,
  });

  useEffect(() => {
    if (dropdownOpen) {
      let isFocused = false;
      isAppViewFocus()
        .then((focused) => {
          isFocused = focused;
          triggerFocus(true);
          return;
        })
        .catch(console.error);

      return () => {
        triggerFocus(isFocused);
      };
    }

    return;
  }, [dropdownOpen]);

  const openDevTools = () => {
    if (tab.activeInnerTabId === undefined) return;
    window.dsDesktop.view.onToggleDevTools(tab.activeInnerTabId);
  };

  return (
    <>
      <Dropdown
        interactive
        align="end"
        open={dropdownOpen}
        onOpenChange={setDropdownOpen}
        triggerElement={
          <Navbar.Button
            variant="tertiary"
            icon={<MoreVerticalOutlineIcon />}
          />
        }
      >
        <DropdownItem
          label={
            <TextBase
              label="Open dev tools"
              color="text-ds-natural-600"
            />
          }
          iconLeft={<ToolsIcon size={20} />}
          onClick={openDevTools}
        />
        {flags.textExtraction &&
          demo.recordingType !== RecordingTypes.overlay && (
            <TextExtractionExport
              onItemClick={downloadExtractedText}
              isDisabled={isCSVEmpty}
            />
          )}
      </Dropdown>
    </>
  );
};
